import { useEffect, useState } from 'react'
import { Column, Icon } from 'rbx'
import { useFetch } from '../../../hooks/useFetch'
import { API_URL } from '../../../services/api'
import Loading from '../../../helpers/Loading'
import moment from 'moment'
import Controls from '../../shared/Controls/Controls'
import { Redirect } from 'react-router-dom'
import { RedirectTo } from '../../../utils/redirectTo'
import { Timer } from '../../shared/Timer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHourglass } from '@fortawesome/free-regular-svg-icons'
import { ZadMap } from '../../shared/ZadMap'
import { MonitorsMarkersLayer } from './MonitorsMarkersLayer'

export const MonitorsNow = () => {
  const [time, setTime] = useState(null)
  const [redirectTo, setRedirectTo] = useState(null)
  const [activeMarker, setActiveMarker] = useState(null)
  const [search, setSearch] = useState('')

  const { 
    response: locationMonitorsResponse,
    load: locationMonitorsLoad,
    refresh: locationMonitorsRefresh
  } = useFetch(`${API_URL}/adm/find-location-monitors`)

  const { 
    response: areasResponse,
    load: areaLoad
  } = useFetch(`${API_URL}/areas`)

  const areasMap = areasResponse?.data||[]

  const minutes = 1

  useEffect(() => {
    setTime(moment())

    if (!locationMonitorsLoad) {
      const interval1 = setInterval(() => {
        locationMonitorsRefresh()
        setTime(moment())
      }, minutes * 60 * 1000)

      return () => clearInterval(interval1)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  // console.log('MonitorsNow', 'Rendered')

  if (redirectTo)
  return <Redirect to={{ pathname: redirectTo }} />

  // O `?.` sozinho NÃO resolvia isto: useFetch inicia `response` como '' (string
  // vazia), e '' não é nullish — `''?.data` avalia normalmente para `undefined`,
  // sem curto-circuitar, e `undefined.filter(...)` lançava TypeError. Bastava
  // digitar na busca antes do primeiro fetch terminar para derrubar a tela. O
  // mesmo vale quando o fetch falha: useFetch seta `response` para `[]`, e
  // `[].data` também é `undefined`. Por isso a checagem é sobre o TIPO do dado.
  const monitors = Array.isArray(locationMonitorsResponse?.data)
    ? locationMonitorsResponse.data
    : []

  const filteredMonitors = search.length > 0
    ? monitors.filter((monitor) => (monitor.name || '').toUpperCase().includes(search))
    : monitors

  const closeInfoWindow = () => {
    setActiveMarker(null)
  }

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return
    }
    closeInfoWindow()
    setActiveMarker(marker)
  }

  const searchContainerStyle = {
    position: 'absolute',
    top: 6,
    left: 4,
    zIndex: 4,
    pointerEvents: 'auto',
    overflow: 'hidden',
    whiteSpace: 'normal',
    fontFamily: '"Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    width: '100%',
    maxWidth: '30rem'
  }

  const timerContainerStyle = {
    background: '#fff',
    fontSize: '1.4rem',
    padding: '0.4rem 0.5rem',
    border: '1px solid hsl(0deg, 0%, 86%)',
    borderRadius: '4px',
    color: 'var(--text-body)',
    maxWidth: '10rem'
  }

  return !areaLoad ? (
    <>
      <div className='search-container' style={searchContainerStyle}>
        <Column.Group gapSize={1} breakpoint='mobile'>
          <Column>
            <Controls.TextFieldWithSearch2 
              name="description"
              placeholder='Pesquisar monitor'
              autoComplete='off'
              onChange={e => {
                closeInfoWindow()
                setSearch(e.target.value.toUpperCase())
              }}
              value={search}
              onClickFirst={()=>setRedirectTo(RedirectTo.dashboard)}
              onClickSecond={() => setSearch('')}
            />
          </Column>
          <Column size={'one-quarter'}>
            <div className='is-flex is-align-items-center' style={timerContainerStyle}>
              <Icon style={{fontSize:'1.5rem', color:'var(--text-title)', paddingLeft:'.2rem'}}>
                <FontAwesomeIcon icon={faHourglass} />
              </Icon>
              <span style={{paddingTop:'.1rem', marginLeft:'1rem'}}>
                <Timer 
                  startDate={time}
                  paidMinutes={minutes} 
                  reverse={true} 
                  format='mm[:]ss'
                />
              </span>
            </div>
          </Column>
        </Column.Group>
      </div>

      <ZadMap
        areasMap={areasMap}
        mapContainerStyle={{ width: '100vw', height: '100vh' }}
        zoom={17}
        onClick={closeInfoWindow}
      >
        {/* A camada é a única dona da identidade do monitor: ela calcula a chave
            do <Marker> e compara com `activeMarker` usando a MESMA expressão.
            Ver MonitorsMarkersLayer.jsx para o porquê da chave estável. */}
        <MonitorsMarkersLayer
          monitors={filteredMonitors}
          activeMarker={activeMarker}
          onMarkerClick={handleActiveMarker}
        />
      </ZadMap>
    </>
  ) : <Loading />
}
